module.exports = __webpack_public_path__ + "static/media/dinein-protocols.c4d91557.jpeg";